import React, { Component } from 'react';
import { connect } from 'react-redux';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import filter from 'ramda/src/filter';
import isNil from 'ramda/src/isNil';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import queryString from 'query-string';
import DatePicker from '@components/@core/DatePicker';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import EditDropdown from '@components/EditDropdown';
import Pagination from '@components/@core/Pagination';
import ToggleColumnMenu from '@components/@core/ToggleColumnMenu';
import AppActions from '~/actions/app';
import ManageActions from '~/actions/manage';
import { SPECIALOPTIONS, EngagementTabs } from '~/services/config';
import { exportCsv } from '~/services/util-excel';
import withNavigate from '~/hocs/withNavigate';
import Body from './Body';
import { KEYS, TITLES } from './Constants';

import EngagementPdf from './EngagementPdf';

const moment = extendMoment(originalMoment);

class Engagement extends Component {
    constructor(props) {
        super(props);

        const today = moment();
        const date = moment.range(today.clone().subtract(7, 'days'), today.clone());
        const activeTab = queryString.parse(props.location?.search || '')?.active || 'trainings';

        this.state = {
            activeTab,
            date,
            companyIds: this.props.selectedCompany,
            userIds: [],
            current: 1,
            per: 25,
            column: 1,
        };
    }

    componentDidMount() {
        const { companies, selectedCompany } = this.props;
        const { activeTab, companyIds, date } = this.state;
        const allCompanies = companies.map((e) => e.id);
        const payload = {
            company_id: selectedCompany[0] === SPECIALOPTIONS.ALL ? allCompanies : companyIds,
            date_start: date.start.format('YYYY-MM-DD'),
            date_end: date.end.format('YYYY-MM-DD'),
        };
        this.props.fetchEngagement(payload, 'company', activeTab);
    }

    handleDate = (date) => {
        const { companies, selectedCompany } = this.props;
        const { activeTab, companyIds } = this.state;
        const allCompanies = companies.map((e) => e.id);
        if (companyIds.length === 0) return;
        const payload = {
            company_id: selectedCompany[0] === SPECIALOPTIONS.ALL ? allCompanies : companyIds,
            date_start: date.start.format('YYYY-MM-DD'),
            date_end: date.end.format('YYYY-MM-DD'),
        };
        this.props.fetchEngagement(payload, 'company', activeTab);
        this.setState({ date });
    };

    handleFilter = (type, e) => {
        const { activeTab, date } = this.state;

        let companyIds = this.state.companyIds;
        let userIds = this.state.userIds;
        let by = 'company';

        if (isNil(e)) return;
        if (type === 'company') {
            if (SPECIALOPTIONS.ALL === e[0].id) {
                companyIds = this.props.companies.map((item) => item.id);
            } else {
                companyIds = e.map((item) => item.id);
            }
            companyIds = filter((a) => a > 0, companyIds);
            this.setState({ companyIds });
        } else if (type === 'employee') {
            by = 'individual';
            if (e[0].id > 0) {
                userIds = e.map((item) => item.id);
            } else {
                userIds = [];
            }
            this.setState({ userIds });
        }

        if (companyIds.length === 0) return;

        const payload = {
            company_id: companyIds,
            date_start: date.start.format('YYYY-MM-DD'),
            date_end: date.end.format('YYYY-MM-DD'),
        };
        this.props.fetchEngagement(payload, by, activeTab);
    };

    handlePage = (e) => {
        this.setState({ current: e });
    };

    handlePer = (e) => {
        this.setState({ per: e });
    };

    handleTabs = (activeTab) => {
        const { companies, selectedCompany } = this.props;
        const { date, companyIds, userIds } = this.state;
        const allCompanies = companies.map((e) => e.id);
        const payload = {
            company_id: selectedCompany[0] === SPECIALOPTIONS.ALL ? allCompanies : companyIds,
            date_start: moment(date.start).format('YYYY-MM-DD'),
            date_end: moment(date.end).format('YYYY-MM-DD'),
        };
        const by = userIds.length === 0 ? 'company' : 'individual';
        this.props.fetchEngagement(payload, by, activeTab);
        this.props.navigate({ search: `?active=${activeTab}` });
        this.setState({ activeTab, column: 1 });
    };

    handleVisible = (column) => {
        this.setState({ column });
    };

    handleExcelReport = () => {
        this.props.toggleModal({
            type: 'Confirm',
            data: {
                before: {
                    title: 'Confirm',
                    body: 'Would you like to download this reports data to excel?',
                },
            },
            callBack: {
                onYes: () => {
                    this.handleExcel();
                },
            },
        });
    };

    handleExcel = () => {
        const { engagements } = this.props;
        const { activeTab } = this.state;
        const data = engagements[activeTab];
        const total = engagements.totals;
        let engagementData = [];
        let keys = [];
        keys.push('Company');
        TITLES[activeTab].map((title) => {
            keys.push(title.join('\n '));
        });
        total.map((total) => {
            let excelData = { Company: 'Total' };
            KEYS[activeTab].map((key) => {
                excelData[key.replace('_', '  \n').toUpperCase()] = `${key.includes('completion') ? total[key]?.complete : total[key]?.count || 0} \n${total[key]?.percent || 0}%`;
            });
            engagementData.push(excelData);
        });
        data.map((company) => {
            let excelData = {
                Company: company.name,
            };
            KEYS[activeTab].map((key) => {
                excelData[key.replace('_', '  \n').toUpperCase()] = `${
                    key.includes('completion') ? company.report[key]?.complete : company.report[key]?.count || 0
                } \n${company.report[key]?.percent || 0}%`;
            });

            engagementData.push(excelData);
        });
        exportCsv(engagementData, keys, `Engagement-${activeTab}`, true);
    };

    handleSelectMenu = (e) => {
        switch (e) {
            case 'print':
                EngagementPdf({ state: this.state, props: this.props });
                break;
            case 'export':
                this.handleExcelReport();
                break;
            default:
                break;
        }
    };
    render() {
        const { engagements } = this.props;
        const { activeTab, current, per, date, column, userIds } = this.state;
        const total = activeTab == 'trainings' || activeTab == 'tasks' || activeTab == 'careers' ? 3 : 4;

        const dotsMenu = ['Print', 'Export'];
        return (
            <ErrorBoundary className="mng-engagement">
                <Filter multi={[true, true]} onChange={this.handleFilter} />
                <div className="card">
                    <div className="d-flex justify-content-between mb-0 mb-md-3">
                        <span className="dsl-b22 bold text-capitalize">Engagement Report</span>
                        <div className="d-flex">
                            <DatePicker calendar="range" append="caret" format="MMM D" as="span" align="right" value={date} closeAfterSelect onSelect={this.handleDate} />
                            <EditDropdown className="ml-3" options={dotsMenu} onChange={this.handleSelectMenu} />
                        </div>
                    </div>
                    <ToggleColumnMenu className="engagement-tabs d-none mb-2" column={column} activeTab={activeTab} total={total} onVisible={this.handleVisible} />
                    <Tabs className="d-md-flex" id="engagement" defaultActiveKey="training" activeKey={activeTab} onSelect={this.handleTabs}>
                        {EngagementTabs.map((tab) => (
                            <Tab key={tab.name} eventKey={tab.name} title={tab.label}>
                                <Body data={engagements[tab.name]} type={tab.name} page={current} per={per} total={engagements.totals} column={column} totalColumn={total} userIds={userIds} />
                                <Pagination current={current} total={Math.ceil(engagements[tab.name].length / per)} onChange={this.handlePage} onPer={this.handlePer} />
                            </Tab>
                        ))}
                    </Tabs>
                </div>
            </ErrorBoundary>
        );
    }
}

const mapStateToProps = (state) => ({
    companies: state.app.companies,
    selectedCompany: state.app.selectedCompany,
    engagements: state.manage.engagementReport,
});

const mapDispatchToProps = (dispatch) => ({
    fetchEngagement: (payload, by, mode) => dispatch(ManageActions.fetchengagementreportRequest(payload, by, mode)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const EngagementWithNavigate = withNavigate(Engagement);

export default connect(mapStateToProps, mapDispatchToProps)(EngagementWithNavigate);
